'use client';

import { c as _c } from "react/compiler-runtime";
import BEMHelper from '@/helpers/bem';
import useEmblaCarousel from 'embla-carousel-react';
import React from 'react';
import styles from './EmblaCarousel.module.scss';
import { usePrevNextButtons } from './usePrevNextButtons';
const bem = BEMHelper(styles);
export default function EntryCarousel(t0) {
  const $ = _c(31);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi);
  let t2;
  if ($[1] !== title) {
    t2 = title && <h2 {...bem("title")}>{title}</h2>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = bem("");
    t4 = bem("nav-button", "prev");
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span {...bem("nav-icon", "prev")} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onPrevButtonClick || $[7] !== prevBtnDisabled) {
    t6 = <button {...t4} type="button" onClick={onPrevButtonClick} disabled={prevBtnDisabled}>{t5}</button>;
    $[6] = onPrevButtonClick;
    $[7] = prevBtnDisabled;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = bem("embla");
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = bem("container");
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== children) {
    t9 = React.Children?.map(children, _temp);
    $[11] = children;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div {...bem("slide", "empty")}><p {...bem("empty")}>Dette var ikke alt! Flere episoder kommer.</p></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <div {...t8}>{t9}{t10}</div>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== emblaRef || $[17] !== t11) {
    t12 = <div {...t7} ref={emblaRef}>{t11}</div>;
    $[16] = emblaRef;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = bem("nav-button", "next");
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span {...bem("nav-icon", "next")} />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== nextBtnDisabled || $[22] !== onNextButtonClick) {
    t15 = <button {...t13} type="button" onClick={onNextButtonClick} disabled={nextBtnDisabled}>{t14}</button>;
    $[21] = nextBtnDisabled;
    $[22] = onNextButtonClick;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t15 || $[26] !== t6) {
    t16 = <section {...t3}>{t6}{t12}{t15}</section>;
    $[24] = t12;
    $[25] = t15;
    $[26] = t6;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16 || $[29] !== t2) {
    t17 = <>{t2}{t16}</>;
    $[28] = t16;
    $[29] = t2;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
}
function _temp(child) {
  if (React.isValidElement(child)) {
    return React.cloneElement(child, {
      className: `${child.props.className || ""} ${bem("slide").className}`
    });
  }
  return child;
}